import { useQuery } from "@tanstack/react-query";
import api from "..";

export const useResourceProviders = () => {
  const { data } = useQuery({
    queryKey: ["provider"],
    queryFn: () =>
      api
        .v1ResourceProviderSearchList({ limit: 100 })
        .then(res => res.data.resources),
  });

  return data;
};

export const useResourceProvider = (ids?: string | string[]) => {
  const { data } = useQuery({
    enabled: Boolean(ids),
    queryKey: ["provider", ids],
    queryFn: () =>
      api
        .v1ResourceProviderList({
          ids: ids as unknown as number[],
        })
        .then(res => res.data[0]),
  });
  return data;
};
